import styles from "./ResourceBrowserSearchButton.module.css";
import SearchSVG from "../SVGs/SearchSVG";
import { useRef } from "react";

function ResourceBrowserSearchButton({
    searchActive,
    setActiveTab,
    setSearchValue,
    onClick,
    handleCloseButton,
}) {
    const inputRef = useRef(null);

    function handleInputChange(e) {
        setSearchValue(e.target.value);
    }

    function handleFocus() {
        setActiveTab("Search");
    }

    return (
        <div
            className={[
                styles.button_container,
                searchActive ? styles.active : "",
            ].join(" ")}
        >
            <div className={styles.overflow_container}>
                <button className={styles.search_button} onClick={onClick}>
                    <SearchSVG />
                </button>
                <input
                    onFocus={handleFocus}
                    name="search"
                    type="text"
                    onChange={handleInputChange}
                    className={styles.search_input}
                    placeholder="Search..."
                    ref={inputRef}
                />
                <button
                    className={[styles.close_button].join(" ")}
                    onClick={() => {
                        inputRef.current.value = "";
                        setSearchValue("");
                        handleCloseButton();
                    }}
                >
                    <img
                        draggable={false}
                        src="/images/search-x.svg"
                        alt="close resource search"
                    />
                </button>
            </div>
        </div>
    );
}

export default ResourceBrowserSearchButton;
